$( document ).ready(function() {
    $(document).on('submit','.component-Order-Deliveries form',function (e)
    {
        e.preventDefault();
        $(this).data('Ajax').done(function(){
            $('html, body').animate({
                scrollTop: $("#component-Order-Deliveries-1").offset().top
            }, 800);
        });
    });
    
});

